import { render, staticRenderFns } from "./MemberBenefitStore.vue?vue&type=template&id=2694cfa2"
import script from "./MemberBenefitStore.vue?vue&type=script&lang=js"
export * from "./MemberBenefitStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports